type ContentType = 'page' | 'product'

export interface OpenAIContent {
  id: string
  name: string
  content_type: ContentType
  quantity?: number
  amount?: number
}

const measure = (event: string, data: object) => {
  try {
    window.oaiq?.('measure', event, data)
  } catch (e) {
    console.warn('[openai pixel error]', e)
  }
}

export const trackContentsViewed = (content: { id: string; name: string }) => {
  measure('contents_viewed', {
    type: 'contents',
    contents: [{ ...content, content_type: 'product' }]
  })
}

export const trackItemsAdded = (payload: {
  amount: number
  currency: string
  contents: OpenAIContent[]
}) => {
  measure('items_added', {
    type: 'contents',
    amount: payload.amount,
    currency: payload.currency,
    contents: payload.contents
  })
}
